import { Layout } from "@/components/layout/Layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const products = [
  {
    id: "textiles",
    title: "Textiles & Garments",
    description: "Premium quality fabrics, ready-made garments, and home textiles from India's renowned textile hubs. From traditional handloom to modern manufacturing, we source apparel and fabrics that meet global quality standards.",
    regions: ["Gujarat", "Tamil Nadu", "Maharashtra", "West Bengal"],
    keyProducts: ["Cotton Fabrics", "Silk Sarees", "Denim", "Knitwear", "Bed Linens", "Towels"],
    image: "https://images.unsplash.com/photo-1558171813-4c088753af8f?w=800&auto=format&fit=crop",
  },
  {
    id: "spices",
    title: "Spices & Agro Products",
    description: "India's finest spices, grains, and agricultural products sourced directly from farmers and certified processors. Experience the authentic flavors and quality that Indian agriculture is celebrated for worldwide.",
    regions: ["Kerala", "Karnataka", "Rajasthan", "Andhra Pradesh"],
    keyProducts: ["Turmeric", "Black Pepper", "Cardamom", "Basmati Rice", "Cashews", "Tea"],
    image: "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?w=800&auto=format&fit=crop",
  },
  {
    id: "machinery",
    title: "Industrial Machinery",
    description: "Heavy equipment, manufacturing tools, and industrial components from India's engineering powerhouses. Reliable machinery solutions for construction, manufacturing, and processing industries.",
    regions: ["Punjab", "Gujarat", "Maharashtra", "Tamil Nadu"],
    keyProducts: ["CNC Machines", "Textile Machinery", "Pumps", "Generators", "Valves", "Hand Tools"],
    image: "https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=800&auto=format&fit=crop",
  },
  {
    id: "handicrafts",
    title: "Handicrafts & Décor",
    description: "Exquisite handcrafted products representing India's rich artistic heritage. From traditional artisans to modern designers, discover unique pieces that tell stories of craftsmanship.",
    regions: ["Rajasthan", "Uttar Pradesh", "Kashmir", "Odisha"],
    keyProducts: ["Brass Work", "Wooden Carvings", "Marble Inlay", "Pottery", "Carpets", "Jewelry"],
    image: "https://images.unsplash.com/photo-1513519245088-0e12902e5a38?w=800&auto=format&fit=crop",
  },
];

const Products = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="py-24 lg:py-32">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-foreground mb-6">
              Our <span className="text-gradient-gold">Products</span>
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
              Explore our diverse range of premium Indian products across multiple categories. 
              Each product is sourced from verified manufacturers and undergoes strict quality control.
            </p>
          </div>
        </div>
      </section>

      {/* Products List */}
      <section className="pb-24">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="space-y-16">
            {products.map((product, index) => (
              <div
                key={product.id}
                id={product.id}
                className={`flex flex-col ${
                  index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
                } gap-8 lg:gap-12 items-center`}
              >
                {/* Image */}
                <div className="w-full lg:w-1/2">
                  <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
                    <img
                      src={product.image}
                      alt={product.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent" />
                  </div>
                </div>

                {/* Content */}
                <div className="w-full lg:w-1/2">
                  <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground mb-4">
                    {product.title}
                  </h2>
                  <p className="text-muted-foreground leading-relaxed mb-6">
                    {product.description}
                  </p>

                  {/* Sourcing Regions */}
                  <div className="mb-6">
                    <h4 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-3">
                      Sourcing Regions
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {product.regions.map((region) => (
                        <span
                          key={region}
                          className="px-3 py-1 text-sm bg-secondary rounded-full text-secondary-foreground"
                        >
                          {region}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Key Products */}
                  <div className="mb-8">
                    <h4 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-3">
                      Key Products
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {product.keyProducts.map((item) => (
                        <span
                          key={item}
                          className="px-3 py-1 text-sm border border-primary/30 rounded-full text-primary"
                        >
                          {item}
                        </span>
                      ))}
                    </div>
                  </div>

                  <Link to={`/contact?product=${encodeURIComponent(product.title)}`}>
                    <Button variant="gold" size="lg">
                      Enquire Now
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Products;
